import { ReactNode } from "react";
import { SceneMetric } from "../stores/use-reports-scene-store";
import { VisibilityInfoModal } from "../modals/visibility-info-modal";
import { POPInfoModal } from "../modals/pop-info-modal";
import { SOAInfoModal } from "../modals/soa-info-modal";
import { POWInfoModal } from "../modals/pow-info-modal";

/**
 * Get the appropriate info modal component based on the scene metric
 *
 * @param metric - The scene metric type (vis, pop, soa, pow)
 * @returns The corresponding info modal component, or null if metric is invalid
 */
export const getSceneInfoModal = (metric: SceneMetric): ReactNode | null => {
  switch (metric) {
    case "vis":
      return <VisibilityInfoModal />;
    case "pop":
      return <POPInfoModal />;
    case "soa":
      return <SOAInfoModal />;
    case "pow":
      return <POWInfoModal />;
    default:
      return null;
  }
};
